export default __webpack_public_path__ + "static/media/DNo.37-6.a232a1c1.jpg";